module.exports = __webpack_public_path__ + "img/pay-icon-10.a9b52702.png";